import { Component, OnInit } from "@angular/core";

import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { CommonService } from "../../shared/common.service";
import { AuthServiceLocal } from "../auth.service";
import { Router } from "@angular/router";
import { HttpResponse } from "@angular/common/http";
import { StreamService } from "../../shared/stream.service";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: "app-delete-account",
  templateUrl: "./delete-account.component.html",
  styleUrls: ["./delete-account.component.scss"],
})
export class DeleteAccountComponent implements OnInit {
  loginForm: FormGroup;
  resetForm: FormGroup;
  formSubmitted: boolean = false;
  isLoading: boolean = false;
  show: boolean = false;
  isLogin: boolean = true;
  emailPattern =
    /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
  message: string = "";
  type: string = "0";
  constructor(
    private fb: FormBuilder,
    private authServices: AuthServiceLocal,
    private commonService: CommonService,
    private streamService: StreamService,
    private router: Router,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.initialiseForms();
    setTimeout(() => {
      this.hasToken();
    }, 100);
  }
  // login() {
  //   this.router.navigate(["main/admin/dashboard"]);
  //
  // }

  initialiseForms() {
    this.loginForm = this.fb.group({
      email: ["", [Validators.required, Validators.pattern(this.emailPattern)]],
      password: ["", [Validators.required, Validators.minLength(6)]],
      type: ["0", [Validators.required]],
    });
    this.resetForm = this.fb.group({
      email: ["", [Validators.required, Validators.pattern(this.emailPattern)]],
    });
  }

  OnchangeType() {}

  validatEmail() {
    this.formSubmitted = true;
    if (this.resetForm.valid) {
      let req = {
        email: this.resetForm.controls["email"].value.toLowerCase(),
      };
      this.isLoading = true;
      this.authServices.verifyEmail(req).subscribe(
        (res) => {
          if ((res["message"] = "Success")) {
            this.resetSubmit();
          } else {
          }
        },
        (err) => {
          this._snackBar.open("Email Verified", "", {
            duration: 3000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ["success"],
          });
        }
      );
    }
  }
  resetSubmit() {
    this.formSubmitted = true;
    if (this.resetForm.valid) {
      let req = {
        email: this.resetForm.controls["email"].value.toLowerCase(),
      };
      this.isLoading = true;
      this.authServices.forgotPassword(req).subscribe(
        (res) => {
          if ((res["message"] = "Success")) {
            this.isLoading = false;
            this.isLogin = true;
            this.initialiseForms();
            this._snackBar.open(
              "Password Forgot successfully , Please check Your mail!!",
              "",
              {
                duration: 3000,
                horizontalPosition: "right",
                verticalPosition: "top",
                panelClass: ["failure"],
              }
            );
          } else {
          }
        },
        (err) => {
          this.isLoading = false;
        }
      );
    }
  }
  userId: any;

  login() {
    this.formSubmitted = true;
    let req = {
      email: this.loginForm.controls["email"].value.trim(),
      password: this.loginForm.controls["password"].value.trim(),
    };

    this.isLoading = true;
    this.authServices.userLogin(req).subscribe(
      (res: HttpResponse<any>) => {
        this.isLoading = false;

        if (
          res["message"] == "Success" ||
          res["body"]["message"] == "Success"
        ) {
          console.log(res, "response");
          this.userId = res["body"]["data"].userId;
          this.commonService.setStorage(
            "token",
            res.headers.get("Authorization")
          );

          if (res.body.data["accessToken"]) {
            this.commonService.setStorage(
              "token",
              res.body.data["accessToken"]
            );
          }
          this.commonService.setStorage("token", res.body.data["accessToken"]);
          if (!res.body.data["accessToken"]) {
            this.commonService.setStorage(
              "token",
              res.headers.get("Authorization")
            );
          }

          let userData = this.commonService.getUser();

          // this.router.navigate(["/main/admin-dashboard"]);
          // localStorage.setItem("role", userData["role"]);
          // localStorage.setItem("activeIndex", "0");
          // this.sendRouteVal(0);
          this.deleteUser();

          // this._snackBar.open(err.error.data, "", {
          //   duration: 3000,
          //   horizontalPosition: "right",
          //   verticalPosition: "top",
          //   panelClass: ["success"],
          // });
        } else {
          this.isLoading = false;
        }
      },
      (err) => {
        // Swal.fire({
        //   icon: "error",
        //   title: err.error.data.message
        // });
        this._snackBar.open(err.error.data, "", {
          duration: 3000,
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: ["success"],
        });
        this.isLoading = false;
      }
    );
  }

  UserId: any;
  deleteUser() {
    this.isLoading = true;
    // debugger;
    this.authServices.deleteUser(this.userId).subscribe(
      (res) => {
        this.isLoading = false;
        // debugger;
        if (res["message"] == "Success") {
          // this.isLoading1 = false;
          // this.modalRef.close();
          this.loginForm.reset();
          this._snackBar.open("User deleted successfully!!", "", {
            duration: 3000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ["failure"],
          });
          window.location.reload();
          // this.getUsersList();
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  navigateForgot(value) {
    if (value == "true") {
      this.isLogin = true;
      this.loginForm.reset();
      this.initialiseForms();
    } else {
      this.isLogin = false;
      this.loginForm.reset();
    }
  }

  sendRouteVal(index) {
    this.streamService.streamMessage(index);
    // this.messageEvent.emit(index);
  }
  password() {
    this.show = !this.show;
  }
  hasToken() {
    let userData = this.commonService.getUser();

    this.router.navigate(["/main/admin-dashboard"]);
    localStorage.setItem("activeIndex", "0");
  }
}
